import Logo from "components/Logo";
import { Link } from "react-router-dom";

const SidebarHeader = ({ sideToggle, headerToggle }) => {
  return (
    <Link
      to={"/"}
      className={`h-[70px] shrink-0 bg-sidebarHeader/70 flex whitespace-nowrap items-center justify-center space-x-2   p-3 shadow-md ${
        headerToggle && "absolute invisible"
      } `}
    >
      <Logo className="w-10 h-10 shrink-0 " />
      <span
        className={`${
          (sideToggle || headerToggle) &&
          "absolute opacity-0 invisible transition-none"
        } transition-all duration-1000 ease-out`}
      >
        KAUST GUARDIAN
      </span>
    </Link>
  );
};

export default SidebarHeader;
